import React, {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useContext,
} from "react";
import { FormData } from "@interfaces/ClientInterface";

// Definimos el tipo para el contexto
interface FormContextType {
  formData: FormData;
  setFormData: Dispatch<SetStateAction<FormData>>;
}

// Creamos el contexto
const FormContext = createContext<FormContextType | undefined>(undefined);

// Definimos las props para el FormProvider
interface FormProviderProps {
  children: ReactNode;
}

// Proveedor del contexto
const FormProvider: React.FC<FormProviderProps> = ({ children }) => {
  const [formData, setFormData] = useState<FormData>({
    uuid: null,
    identificationType: null,
    documentType: null,
    document: null,
    username: null,
    password: null,
    email: null,
    birthDate: null,
    name: null,
    lastname: null,
    gender: null,
    maritalStatus: null,
    phone: null,
  });

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};

export { FormProvider, FormContext };

export const useRegisterContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error(
      "useRegisterContext must be used within a RegisterProvider"
    );
  }
  return context;
};
